import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const REASONGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ReasonGroup.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.ReasonGroup.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const REASONGROUP_CONFIG = {
  entityName: 'ReasonGroup',
  localizationKey: 'General::Entity.ReasonGroup',
  fields: REASONGROUP_FIELDS,
  permission: 'ControllingActivities.ReasonGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
